module.exports = __webpack_public_path__ + "img/slide_interno_tisanas.8e72f49a.webp";